import { useState } from "react";

export const useLocalStorageState = (key: string, initialState?: any) => {
  const [localStorageValue, setLocalStorageValue] = useState(() => {
    try {
      const value = sessionStorage.getItem(key)
      if (value) {
        return JSON.parse(value)
      } else {
        sessionStorage.setItem(key, JSON.stringify(initialState));
        return initialState
      }
    } catch (error) {
      sessionStorage.setItem(key, JSON.stringify(initialState));
      return initialState
    }
  });

  // this method update our localStorage and our state
  const setLocalStorageStateValue = (valueOrFn: any) => {
    let newValue;
    if (typeof valueOrFn === 'function') {
      const fn = valueOrFn;
      newValue = fn(localStorageValue)
    }
    else {
      newValue = valueOrFn;
    }
    sessionStorage.setItem(key, JSON.stringify(newValue));
    setLocalStorageValue(newValue)
  }
  return [localStorageValue, setLocalStorageStateValue]
}

